<template>
  <div class="content">
    <img :src="snowImg"  class="snow"/>
     <div class="words">
      <img :src="titImg" />
      <div class="text">
        <p>2021</p>
        <p>冬至，是我国农历中一个非常重要的节气，也是一个传统节日，至今仍有不少地方有过冬至节的习俗。冬至俗称“冬节”“长至节”“亚岁”等。时间在每年的阳历12月21日和23日之间。</p>
        <p>冬至这天，太阳虽低、白昼虽短，但是在气象上，冬至的温度并不是最低。实际上，由于地表尚有“积热”，冬至之前通常不会很冷，真正的严寒在冬至之后。时至冬至，标志着即将进入寒冷时节，民间由此开始“数九”计算寒天。</p>
      </div>
    </div>
     <div class="words part2 ">
      <img :src="wordPart2Img" />
      <div class="text1">
        <p class="title">01</p>
        <p class="title2">冬至 · 美食</p>
        <p>冬至·岁月难禁节物催</p>
        <p>宋·陆游</p>
        <p>岁月难禁节物催，天涯回首意悲哀。</p>
        <p>十年人向三巴老，一夜阳从九地来。</p>
        <p>上马出门愁敛版，还家留客强传杯。</p>
        <p>探春漫道江梅早，盘里酥花也斗开。</p>
      </div>
    </div>
    <div class="words part3">
      <div class="text">
        <p> 冬至经过数千年发展，形成了独特的节令食文化。诸如馄饨、饺子、汤圆、赤豆粥、黍米糕等都可作为年节食品。曾较为时兴的“冬至亚岁宴”的名目也很多，如吃冬至肉、献冬至盘、供冬至团、馄饨拜冬等。在此我们也向大家推荐适合冬季的食谱。</p>
      </div>
    </div>
    <div class="con_bg">
      <div class="mainCon">
        <div class="main">
          <ul class="booklist" id="list1">
            <li class="bookLi" v-for="(item,index) in bookList[0].list" :key="index">
              <div class="bookLi1">
                <div class="bookImg">
                <a :href="item.url" target="_blank">
                  <img :src="item.cover" />
                </a>
              </div>
              
              </div>
              <div>
                <div class="bookInfor">
                  <h3 class="bookName">
                    <a :href="item.url" target="_blank">{{item.name}}</a>
                  </h3>
                  <div class="intro">{{item.intro}}</div>
                  <p class="btn-box">
                    <a :href="item.url" target="_blank" class="btn"><img :src="gobtn"></a>
                  </p>
                  
                </div>
                
              </div>
              
            </li>
          </ul>
          <div class="z1"></div>
        </div>
      </div>
    </div>
    <!-- 第二部分 -->
    <div class="words part2 list2">
      <img :src="wordPart3Img"   class="part2img"/>
      <div class="text1">
        <p class="title">02</p>
        <p class="title2">冬至 · 诗歌</p>
        <p>冬至过节源于汉代，盛于唐宋，相沿至今。《清嘉录》甚至有“冬至大如年”之说。这表明古人对冬至十分重视。人们认为冬至是阴阳二气的自然转化，是上天赐予的福气。汉朝以冬至为“冬节”，官府要举行祝贺仪式称为“贺冬”，例行放假。故此，诗歌流传颇多。</p>
      </div>
    </div>
    <div class="con_bg">
          <div class="mainCon">
            <div class="main">
              <ul class="booklist" id="list2">
                <li class="bookLi" v-for="(item,index) in bookList[1].list" :key="index">
                  <div class="bookLi1">
                    <div class="bookImg">
                      <a :href="item.url" target="_blank">
                        <img :src="item.cover" />
                      </a>
                    </div>
                  </div>

                  <div>
                    <div class="bookInfor">
                        <h3 class="bookName">
                          <a :href="item.url" target="_blank">{{item.name}}</a>
                        </h3> 
                        <div class="intro">{{item.intro}}</div>
                        <p>
                          <a :href="item.url" target="_blank" class="btn"><img :src="gobtn"></a>
                        </p>
                    </div>
                  </div>
                
                </li>
              </ul>
            </div>
          </div>
    </div>
    <!-- 第三部分 -->
    <div class="words part2 list3">
      <div class="text1">
        <p class="title">03</p>
        <p class="title2">冬至 · 绘本</p>
        <p>大家对于冬季食谱以及诗歌有了一定了解，在这里，我们为孩子们推出了绘本，帮助孩子们对冬至有更深的了解。</p>
      </div>
    </div>

    <div class="con_bg">
          <div class="mainCon">
            <div class="main">
              <ul class="booklist" id="list3">
                <li class="bookLi" v-for="(item,index) in bookList[2].list" :key="index">
                  <div class="bookLi1">
                    <div class="bookImg">
                      <a :href="item.url" target="_blank">
                        <img :src="item.cover" />
                      </a>
                    </div>
                  </div>

                  <div>
                    <div class="bookInfor">
                        <h3 class="bookName">
                          <a :href="item.url" target="_blank">{{item.name}}</a>
                        </h3> 
                        <div class="intro">{{item.intro}}</div>
                        <p>
                          <a :href="item.url" target="_blank" class="btn"><img :src="gobtn"></a>
                        </p>
                    </div>
                  </div>
                
                </li>
              </ul>
            </div>
          </div>
    </div>
     

<div class=" footer footMain" style="text-align:center">
    <img :src="footerImg">
  
  <div class="links">
    <p>
      <a href="/main/about.htm">关于我们</a>
      |
      <a href="/main/copyright.htm">版权声明</a>
      |
      <a href="/main/lineService.htm">在线客服</a>
      |
      <a href="/main/help.htm">常见问题</a>
      |
      <a href="/main/readme.htm">积分说明</a>
      |
      <a href="/main/partnership.htm">商务合作</a>
      |
      <a href="/main/contact.htm">联系我们</a>
    </p>
    <p>
      <a href="http://www.miitbeian.gov.cn" target="_blank">京ICP备10214027号-3</a> 京网文(2015)0513-193号 增值电信业务经营许可证沪B2-20090110
    </p>
    <p>
      © 2018
      <span>中文在线</span> 书香中国为中文在线旗下网站未经许可严禁转载
    </p>
  </div> 
  </div>
  </div>

</template>

<script>
import { bookList } from "../../assets/js/data";
export default {
  name: "content",
  data() {
    return {
      returnUrl: "/static-topic/dongzhi/index_pc.html&boot=false",    
      wordPart2Img:require("../../assets/img/pc/1.png"),
      wordPart3Img:require("../../assets/img/pc/2.png"),
      titImg: require("../../assets/img/pc/text2.png"),
      gobtn: require("../../assets/img/pc/btn.png"),
      snowImg:require("../../assets/img/pc/snow.png"),
      footerImg:require("../../assets/img/pc/3.jpg")
    };
  },
  computed: {
    bookList() {
      return bookList;
    }
  },
  methods: {
    getUrl() {}
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .snow{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 4;
  }
.content {
  position: relative;
  padding-top: 1.25rem;

  .words{
    font-size: 0.48rem;
    color: #1B1B1B;
    font-family: '黑体','宋体';
    font-weight: bold;
    line-height: 1.5em;
    >img{
      width: 100%;
    }
    .text{
      padding: 0.5rem 0.57rem 0.57rem;
      >p{

          text-align: left;
          text-indent:2em;
        }
      >p:first-child{
        text-indent:0;
      } 
      >p+p{
        margin-top: 0.2rem;
      }
      
    }
    

  }
  
  .words.part2{
    position: relative;
    >img{
      width: 6.52rem;
      height: 6.98rem;
      position: absolute;
      top: 0;
      left: 0;
    }
    .text1{
      width: 11rem;
      height: auto;
      margin: auto;
      padding-top: 0.5rem;
      .title{
        font-size: 0.6rem;
        letter-spacing: 0.05rem;
      }
      .title2{
        text-align: left;
        margin-top: 0.65rem;
      }
      >p+p{
        margin-top: 0.15rem;
      }
      >p:nth-child(3){
        margin-top: 0.7rem;
      }
      >p:nth-child(4){
        margin: 0.2rem auto;
      }
  }
  }

  .words.list2{
    padding-bottom: 1rem;
    >img.part2img{
      width: 100%;
      height: auto;
      position: absolute;
      top: -3rem;
      left: 0;
    }
    .text1{
      width: 80%;
      >p:nth-child(3){
        text-align: left;
        text-indent:2em;

      }
    }

  }
  .words.list3{
    margin-top: 0.6rem;
    .text1{
      width: 80%;
      >p:nth-child(3){
     
      text-align: left;
      text-indent: 2em;
    }
    }
  }
  .words.part3{
    .text{
      margin-top: .4rem;
      >p{
      text-indent:2em;
      }
    }
    
  }
  // margin: -6.3rem auto 0;
  .con_bg {
    position: relative;
    width: 100%;
    background-size: 100% 100%;
    padding: 0 0.6rem;
    z-index: 5;
  }

  .activity {
    width: 100%;
    margin-bottom: 0.3rem;
    .actTit {
      width: 100%;
      .titImg {
        padding: 0 0.1rem;
        margin-bottom: 0.25rem;
        img {
          
          height: 0.29rem;
        }
      }

      .text {
        font-size: 0.24rem;
        line-height: 0.4rem;
        color: #405656;
      }
    }
  }
  .htitle {
    margin-bottom: 0.25rem;
    img {
      width: 2.93rem;
    }
  }
  .info {
    margin-bottom: 0.3rem;
    img {
      width: 2.93rem;
    }
    .dec {
      width: 100%;
      .prize {
        height: 1.88rem;
        margin-bottom: 0.26rem;
        img {
          width: 1.88rem;
          height: 1.88rem;
        }
      }
      p {
        margin-bottom: 0.2rem;
        color: #443433;
      }
      .level {
        font-size: 0.26rem;
        font-weight: bold;
        color: #e10a30;
      }
      .name {
        color: #e10a30;
      }
      .sm {
        margin-bottom: 0.3rem;
        color: #e10a30;
      }
      .activeDec {
        text-align: left;
        margin-bottom: 0.4rem;
        font-size: 0.24rem;
        p {
          margin-bottom: 0.35rem;
          line-height: 0.4rem;
        }
        .bold {
          font-weight: bold;
        }
      }
    }
    .gobtn {
      display: inline-block;
      height: 0.64rem;
      margin-bottom: 0.3rem;
      img {
        width: 2.5rem;
        height: 0.64rem;
      }
    }
    .mark {
      text-align: left;
      color: #405656;
    }
  }

  .booklist {
    // padding: 0.4rem 0.35rem;
    // border: 0.03rem solid #de0027;
   display: flex;
   flex-wrap: wrap;
    li {
      width: 50%;
      display: flex;
      margin-top: 0.8rem;
      .bookImg {
        width: 2.4rem;
        height: auto;
        margin-right: 0.3rem;
        box-shadow: 0 0.08rem 0.09rem 0.01rem rgba(81, 78, 78, 0.45);
        a {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .bookInfor {
        width: 94%;
        height: 100%;
        display: flex;
        flex-direction: column;
        color: #1B1B1B;
        text-align: left;
        font-family: '黑体','宋体';
        font-weight: bold;
        position: relative;
        .btn-box{
          width: 100%;
          .btn{
            >img{
              width: 3.6rem;
              height: auto;
            }
          }
        }
        .bookName {
          font-size: 0.32rem;
          font-weight: bold;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
          a {
            color:#1B1B1B ;
          }
        }
        .author {
          line-height: 0.56rem;
 
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .intro {
          line-height: 0.3rem;
          font-size: 0.28rem;
          line-height: 1.2em;
          margin-top: .2rem;
          margin-bottom: 0.14rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .btn {
          display: inline-block;
          width: 1.46rem;
          height: 0.5rem;
          line-height: 0.5rem;
          text-align: center;
          >img{
            width: 4rem;
            position: absolute;
            left: 0;
            bottom: 0;
          } 
        }
      }
    }
  }
  
}
.footer{
    width: 100%;
    height: auto;
    position: relative;
    >img{
      width: 100%;
      //position: absolute;
      top: 0.2rem;
      left: 0;
      z-index: 1;
    }
}
.footMain{
  color: #1B1B1B;
  font-size: 0.2rem;
  height: auto;
  min-height: 11rem;
  padding-top:0.78rem ;
  a{
      color: #1B1B1B;
  }
  p{
    line-height: 0.4rem;
  }
  .links{
    position: absolute;
    left: 0;
    bottom: 1rem;
    width: 100%;
    z-index: 2;
  }
}
</style>
